import "client-only";
import useSWR from "swr";
import { fetcher } from "../../utils/fetcher";
function useProvinceList(params) {
  return useSWR(
    !!params
      ? {
          path: `/api/v1/addresses/provinces`,
          method: "GET",
          params,
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useProvinceList;
